// extracted by mini-css-extract-plugin
export default {"badge":"badge--pnial","l":"l--qSyO2","main":"main--JPQjm","alt":"alt--K3tF4"};